import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "cart-checkout__shipping" };
const _hoisted_2 = { class: "mb-2 ml-2" };
const _hoisted_3 = { class: "mb-4 data-box__select" };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_7 = {
    key: 0,
    style: { "flex": "1 1 auto" },
    class: "text-end"
};
const _hoisted_8 = { class: "text-muted" };
const _hoisted_9 = {
    key: 0,
    class: "item-secondary"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "col-md-6" };
const _hoisted_14 = {
    key: 1,
    class: "item-secondary"
};
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-md-3" };
const _hoisted_18 = { class: "col-md-3" };
const _hoisted_19 = { class: "col-md-6" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2" })
    ])
], -1);
const _hoisted_21 = { class: "row" };
const _hoisted_22 = { class: "col-md-6" };
const _hoisted_23 = { class: "col-md-6" };
const _hoisted_24 = { class: "mb-2 ml-2" };
const _hoisted_25 = { class: "mb-4 data-box__select" };
const _hoisted_26 = { class: "item" };
const _hoisted_27 = ["value"];
const _hoisted_28 = { class: "fw-bold" };
const _hoisted_29 = ["onUpdate:modelValue", "value"];
const _hoisted_30 = ["onUpdate:modelValue", "true-value"];
const _hoisted_31 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_32 = { class: "fw-bold" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_form, {
            ref: "frmMain",
            "data-object": _ctx.data
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.DeliveryAddress')), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.delivery, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        name: "deliveryAddressMode",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.addresses.delivery.mode) = $event)),
                                        value: item.name
                                    }, null, 8, _hoisted_5), [
                                        [_vModelRadio, _ctx.data.addresses.delivery.mode]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", null, _toDisplayString(item.caption), 1),
                                    (item.name === _ctx.data?.addresses?.delivery?.mode || !item.hideIfNotSelected)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createElementVNode("span", _hoisted_8, [
                                                _createVNode(_component_g_dynamic_html, {
                                                    template: item.description,
                                                    templateProps: { item: item, data: _ctx.data }
                                                }, null, 8, ["template", "templateProps"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (_ctx.data?.addresses?.delivery?.mode === item.name && item.name === 'address')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createElementVNode("div", null, [
                                        _createVNode(_component_g_select_field, {
                                            label: "Adresse",
                                            "data-member": "addresses.delivery.addressID",
                                            "data-object": _ctx.data,
                                            "data-mode": "model",
                                            "show-label": false,
                                            "item-source": item.addresses,
                                            "value-expr": "addressID",
                                            "display-expr": "displayName",
                                            "validation-rules": { required: true }
                                        }, null, 8, ["data-object", "item-source"]),
                                        (_ctx.data?.addresses?.delivery?.addressID)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_g_text_field, {
                                                    label: "Anspechpartner",
                                                    "data-member": "addresses.delivery.contactName",
                                                    "data-object": _ctx.data,
                                                    "data-mode": "model"
                                                }, null, 8, ["data-object"]),
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createVNode(_component_g_text_field, {
                                                            label: "E-Mail-Adresse",
                                                            "data-member": "addresses.delivery.eMail",
                                                            "data-object": _ctx.data,
                                                            "data-mode": "model"
                                                        }, null, 8, ["data-object"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createVNode(_component_g_text_field, {
                                                            label: "Telefon",
                                                            "data-member": "addresses.delivery.telephone",
                                                            "data-object": _ctx.data,
                                                            "data-mode": "model"
                                                        }, null, 8, ["data-object"])
                                                    ])
                                                ])
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.data?.addresses?.delivery?.mode === item.name && item.name === 'custom')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("div", null, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Name 1",
                                            "data-member": "addresses.delivery.name1",
                                            "max-length": "50",
                                            "validation-rules": { required: true }
                                        }),
                                        _createVNode(_component_g_text_field, {
                                            label: "Name 2",
                                            "data-member": "addresses.delivery.name2",
                                            "max-length": "50"
                                        }),
                                        _createVNode(_component_g_text_field, {
                                            label: "Zusatz",
                                            "data-member": "addresses.delivery.addition",
                                            "max-length": "64"
                                        }),
                                        _createVNode(_component_g_text_field, {
                                            label: "Straße",
                                            "data-member": "addresses.delivery.street",
                                            "max-length": "64",
                                            "validation-rules": { required: true }
                                        }),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _createVNode(_component_g_select_field, {
                                                    label: "Land",
                                                    "data-member": "addresses.delivery.country",
                                                    "item-source": _ctx.schema.dataSources.countries_delivery,
                                                    "value-expr": "name",
                                                    "display-expr": "caption"
                                                }, null, 8, ["item-source"])
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                                _createVNode(_component_g_text_field, {
                                                    label: "Plz",
                                                    "data-member": "addresses.delivery.zipCode",
                                                    "update-lazy": true,
                                                    "max-length": "24",
                                                    "validation-rules": { required: true }
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createVNode(_component_g_text_field, {
                                                    label: "Ort",
                                                    "data-member": "addresses.delivery.city",
                                                    "max-length": "40",
                                                    "validation-rules": { required: true }
                                                })
                                            ])
                                        ]),
                                        _hoisted_20,
                                        _createVNode(_component_g_text_field, {
                                            label: "Anspechpartner",
                                            "data-member": "addresses.delivery.contactName",
                                            "data-object": _ctx.data,
                                            "data-mode": "model"
                                        }, null, 8, ["data-object"]),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createVNode(_component_g_text_field, {
                                                    label: "E-Mail-Adresse",
                                                    "data-member": "addresses.delivery.eMail",
                                                    "data-object": _ctx.data,
                                                    "data-mode": "model"
                                                }, null, 8, ["data-object"])
                                            ]),
                                            _createElementVNode("div", _hoisted_23, [
                                                _createVNode(_component_g_text_field, {
                                                    label: "Telefon",
                                                    "data-member": "addresses.delivery.telephone",
                                                    "data-object": _ctx.data,
                                                    "data-mode": "model"
                                                }, null, 8, ["data-object"])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 64));
                    }), 256))
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ShippingMode')), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.shipping, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        name: "shippingMode",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.data.shipping.mode) = $event)),
                                        value: item.name
                                    }, null, 8, _hoisted_27), [
                                        [_vModelRadio, _ctx.data.shipping.mode]
                                    ])
                                ]),
                                _createElementVNode("div", null, _toDisplayString(item.caption), 1),
                                _createElementVNode("div", _hoisted_28, _toDisplayString(item.amountText), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.options, (option) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (item.name === _ctx.data?.shipping?.mode)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(['item-secondary', option?.seperator ? 'seperator' : ''])
                                        }, [
                                            _createElementVNode("div", null, [
                                                (option.mode === 'RADIO')
                                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 0,
                                                        type: "radio",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.data.shipping['option_' + option.name]) = $event),
                                                        value: option.value
                                                    }, null, 8, _hoisted_29)), [
                                                        [_vModelRadio, _ctx.data.shipping['option_' + option.name]]
                                                    ])
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 1,
                                                        type: "checkbox",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.data.shipping['option_' + option.name]) = $event),
                                                        "false-value": "",
                                                        "true-value": option.value
                                                    }, null, 8, _hoisted_30)), [
                                                        [_vModelCheckbox, _ctx.data.shipping['option_' + option.name]]
                                                    ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("div", null, _toDisplayString(option.caption), 1),
                                                (option.mode === 'AVIS' && _ctx.data.shipping['option_' + option.name] === option.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                        _createVNode(_component_g_text_field, {
                                                            label: "Name (Vorname, Nachname)",
                                                            "data-member": 'shipping.option_' + option.name + '_contactName',
                                                            "validation-rules": { required: true }
                                                        }, null, 8, ["data-member"]),
                                                        _createVNode(_component_g_text_field, {
                                                            label: "eMail-Adresse",
                                                            "data-member": 'shipping.option_' + option.name + '_contactMail',
                                                            mode: "email",
                                                            "data-mode": "model",
                                                            "data-object": _ctx.data,
                                                            "validation-rules": { required: true, type: 'email' }
                                                        }, null, 8, ["data-member", "data-object"]),
                                                        _createVNode(_component_g_text_field, {
                                                            label: "Telefonnummer",
                                                            "data-member": 'shipping.option_' + option.name + '_contactPhone',
                                                            mode: "phone",
                                                            "data-mode": "model",
                                                            "data-object": _ctx.data,
                                                            "validation-rules": { required: true }
                                                        }, null, 8, ["data-member", "data-object"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_32, _toDisplayString(option.amountText), 1)
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ], 64));
                    }), 256))
                ])
            ]),
            _: 1
        }, 8, ["data-object"])
    ]));
}
